module.exports = __webpack_public_path__ + "static/media/5.0e5a0fe8.jpg";